import { useAppSelector } from 'store/hooks'

export type AddressSliceKey = 'default' | 'company'

// Хук для выбора стейта адреса по ключу слайса
export const useAddressState = (key: AddressSliceKey = 'default') =>
  useAppSelector(state =>
    key === 'company' ? state.companyAddress : state.address,
  )
